<template>
  <div>
    <b-row>
      <b-col md="12" class="filter-container">
        <b-form-group label="Date Range" class="date">
          <v-date-picker
            v-model="dateRange"
            :first-day-of-week="1"
            mode="range"
            :input-props="{
              placeholder: 'Please select date range'
            }"
            :masks="{ input: 'YYYY/MM/DD' }"
          ></v-date-picker>
        </b-form-group>
        <b-form-group label="Type" class="type">
          <b-form-select
            v-model="type"
            :options="options"
            value-field="value"
            text-field="text"
            class="mb-3 select-custom"
          >
            <template v-slot:first>
              <option :value="null" disabled>-- Please select a Type --</option>
            </template>
          </b-form-select>
        </b-form-group>
        <b-form-group label="User" class="type">
          <b-form-select
            v-model="userId"
            :options="userOptions"
            value-field="value"
            text-field="text"
            class="mb-3 select-custom"
          >
            <template v-slot:first>
              <option :value="null" disabled>-- Please select a User --</option>
            </template>
          </b-form-select>
        </b-form-group>
        <b-button
          pill
          variant="outline-primary ripple"
          class="clear-btn"
          size="sm"
          @click="clear"
          >Clear</b-button
        >
      </b-col>
    </b-row>
    <b-row>
      <b-table
        th-class="cursor-pointer"
        striped
        hover
        bordered
        :items="filteredLeaveItems"
        :fields="fields"
      >
        <template v-slot:cell(Type)="row">
          <div>
            <span>{{ row.item.Type.seperateByCapitalLetter() }}</span> <br />
            <b-badge v-if="!row.item.Approved" pill variant="danger"
              >Unapproved</b-badge
            >
          </div>
        </template>

        <template v-slot:cell(actions)="row">
          <div class="actions">
            <b-button
              v-if="!row.item.Approved"
              size="sm"
              variant="info"
              @click="approveModal(row.item)"
            >
              Respond
            </b-button>
            <b-button
              v-else
              size="sm"
              variant="danger"
              @click="rejectModal(row.item)"
            >
              Reject
            </b-button>
          </div>
        </template>
      </b-table>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "LeaveGrid",
  apollo: {
    leaveItems: {
      query: require("@/graphql/Leave/GetLeaveItems.gql"),
      update(data) {
        return data?.getLeaveItems?.sort((a, b) => (a?.from > b?.from ? 1 : -1))
      }
    },
    users: {
      query: require("@/graphql/Account/GetUsers.gql"),
      update(data) {
        data?.users
          ?.removeUnassigned()
          ?.sortBy(x => x.firstName)
          ?.forEach(user => {
            this.userOptions.push({
              text: this.$utils.getUserName(user),
              value: user.id
            })
          })
        return data?.users
      }
    }
  },
  data() {
    return {
      dateRange: {
        start: null,
        end: null
      },
      options: [],
      userOptions: [],
      type: null,
      userId: null,
      fields: []
    }
  },
  computed: {
    ...mapGetters({
      getUser: "getUserById"
    }),
    filteredLeaveItems() {
      if (!this.leaveItems) return []
      let leaveItems = this.leaveItems.map(x => {
        return {
          ...x,
          from: new Date(x.from),
          to: new Date(x.to)
        }
      })

      if (
        this.dateRange.start == null &&
        this.type == null &&
        this.userId == null
      ) {
        let items = leaveItems
          .filter(
            x =>
              x.from >= this.formattedDate(0) && x.to <= this.formattedDate(11)
          )
          .map(x => {
            return {
              Approved: x.approved,
              from: this.$moment(x.from).format("DD MMMM YYYY"),
              to: this.$moment(x.to).format("DD MMMM YYYY"),
              Reason: x.reason,
              Type: x.type,
              FirstName: x.user.firstName,
              LastName: x.user.lastName,
              id: x?.id ?? ""
            }
          })
        return items
      }

      let items = leaveItems
        .filter(
          x =>
            //Date range filter
            (!this.dateRange.start ||
              (x.from >=
                (this.dateRange.start ?? Date.parse(this.formattedDate(0))) &&
                x.to <=
                  (this.dateRange.end ??
                    Date.parse(this.formattedDate(11))))) &&
            //Type filter
            (!this.type ||
              (this.type == "Unapproved" && !x.approved) ||
              x.type == this.type) &&
            //User filter
            (!this.userId ||
              (x.user?.id != null && x.user.id == this.userId)) &&
            x.id !== null
        )
        ?.map(x => {
          return {
            Approved: x.approved,
            from: this.$moment(x.from).format("DD MMMM YYYY"),
            to: this.$moment(x.to).format("DD MMMM YYYY"),
            Reason: x.reason,
            Type: x.type,
            FirstName: x?.user?.firstName ?? "Unknown",
            LastName: x?.user?.lastName ?? "Unknown",
            id: x.id == null ? "" : x.id
          }
        })
      return items
    }
  },
  created() {
    // this.loading = false
    this.options = [
      { value: "Unapproved", text: "Unapproved" },
      { value: "Leave", text: "Leave" },
      { value: "SickLeave", text: "Sick Leave" },
      { value: "StudyLeave", text: "Study Leave" }
    ]
    this.fields = [
      //   { key: "Approved", sortable: true },
      { key: "FirstName", sortable: true },
      { key: "LastName", sortable: true },
      { key: "from", sortable: true },
      { key: "to", sortable: true },
      { key: "Type", sortable: true },
      { key: "Reason", sortable: true },
      { key: "Actions", sortable: false }
    ]
  },
  methods: {
    clear() {
      this.type = null
      this.userId = null
      this.dateRange = { start: null, end: null }
    },
    /**
     *
     * @param leave
     * @returns {*|string}
     */
    getleaveType(leave) {
      const leaveTypes = {
        Leave: "Leave",
        SickLeave: "Sick Leave",
        StudyLeave: "Study leave",
        default: "Leave"
      }
      return leaveTypes[leave] || leaveTypes["default"]
    },
    /**
     *
     * @param leaveItem
     */
    approveModal(leaveItem) {
      this.$bvModal
        .msgBoxConfirm(
          `Approve ${this.getleaveType(leaveItem.type)} for ${
            leaveItem.FirstName
          } ${leaveItem.LastName}? from ${this.$moment(leaveItem.from).format(
            "Y/MM/D"
          )} to ${this.$moment(leaveItem.to).format("Y/MM/D")}?`,
          {
            title: "Approval",
            size: "lg",
            buttonSize: "lg",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0 ",
            footerClass: "p-2 border-top-0 ",
            centered: true,
            okTitle: "Approve",
            cancelTitle: "Reject",
            cancelVariant: "danger"
          }
        )
        .then(async value => {
          if (value) {
            await this.leaveApproved(await this.approveLeaveItem(leaveItem.id))
          } else if (value === false) {
            await this.leaveRejected(await this.rejectLeaveItem(leaveItem.id))
          }
        })
        .catch(() => {
          this.$toasted.error("An error occured")
        })
    },
    /**
     *
     * @param leaveItem
     */
    rejectModal(leaveItem) {
      this.$bvModal
        .msgBoxConfirm(
          `Reject previously approved ${this.getleaveType(
            leaveItem.type
          )} for ${leaveItem.FirstName} ${
            leaveItem.LastName
          }? from ${this.$moment(leaveItem.from).format(
            "Y/MM/D"
          )} to ${this.$moment(leaveItem.to).format("Y/MM/D")}?`,
          {
            title: "Reject",
            size: "lg",
            buttonSize: "lg",
            okVariant: "danger",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
            okTitle: "Reject",
            cancelTitle: "Cancel",
            cancelVariant: "success"
          }
        )
        .then(async value => {
          if (value)
            await this.leaveRejected(await this.rejectLeaveItem(leaveItem.id))
        })
        .catch(error => {
          console.log(error)
          this.$toasted.error("An error occured")
        })
    },
    /**
     * Approves leave item
     * @param leaveId
     * @returns {Promise<*>}
     */
    async approveLeaveItem(leaveId) {
      const response = await this.$apollo.mutate({
        mutation: require("@/graphql/Leave/ApproveLeave.gql"),
        variables: {
          leave: {
            id: leaveId
          }
        }
      })
      return response.data.approveLeave
    },
    /**
     * Rejects leave item
     * @param leaveId
     * @returns {Promise<*>}
     */
    async rejectLeaveItem(leaveId) {
      const response = await this.$apollo.mutate({
        mutation: require("@/graphql/Leave/RejectLeave.gql"),
        variables: {
          leave: {
            id: leaveId
          }
        }
      })
      return response.data.rejectLeave
    },
    /**
     * Updates leaveItems data and notifies user that the leave was approved successfully.
     * @param leaveItem
     * @returns {Promise<void>}
     */
    async leaveApproved(leaveItem) {
      Object.assign(
        this.leaveItems.find(x => x.id == leaveItem.id),
        leaveItem
      )
      this.$toasted.success("Leave approved")
    },
    /**
     * Updates leaveItems data and notifies user that the leave was rejected successfully.
     * @param leaveItem
     * @returns {Promise<void>}
     */
    async leaveRejected(leaveItem) {
      this.lodash.remove(this.leaveItems, item => {
        return item.id === leaveItem.id
      })
      //Needed for calendar to update state
      this.leaveItems = this.leaveItems.map(x => x)
      this.$toasted.success("Leave rejected")
    },
    formattedDate(monthIncrement) {
      let today = new Date()

      if (monthIncrement > 0) {
        today = new Date(today.setMonth(today.getMonth() + monthIncrement))
      }

      return today
    }
  }
}
</script>

<style scoped>
.filter-container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  padding: 0;
  margin: 0;
}
.clear-btn {
  height: 2rem;
  margin: auto 0 auto 0;
}
.type {
  flex: 0.3;
}
.date {
  flex: 0.3;
}
.actions {
  padding: 1rem;
  text-align: center;
}

div.actions > button {
  margin: 0.2rem 0;
  width: 75%;
}
</style>
<style>
.modal-content {
  background: whitesmoke !important;
}
</style>
